var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_564_355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9163 0.488281C5.77111 0.488281 0.771973 5.48742 0.771973 11.6326C0.771973 17.7778 5.77111 22.777 11.9163 22.777C18.0615 22.777 23.0607 17.7778 23.0607 11.6326C23.0607 5.48742 18.0628 0.488281 11.9163 0.488281ZM11.9163 21.4818C6.48546 21.4818 2.06843 17.0635 2.06843 11.6339C2.06843 6.20436 6.48676 1.78474 11.9163 1.78474C17.3459 1.78474 21.7642 6.20307 21.7642 11.6326C21.7642 17.0622 17.3459 21.4805 11.9163 21.4805V21.4818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.826 10.9568H12.5114V6.59159C12.5114 6.23377 12.221 5.94336 11.8632 5.94336C11.5054 5.94336 11.215 6.23377 11.215 6.59159V10.9568H6.90165C6.54382 10.9568 6.25342 11.2472 6.25342 11.605C6.25342 11.9628 6.54382 12.2532 6.90165 12.2532H11.2163V16.5173C11.2163 16.8751 11.5067 17.1655 11.8645 17.1655C12.2223 17.1655 12.5127 16.8751 12.5127 16.5173V12.2532H16.8273C17.1852 12.2532 17.4756 11.9628 17.4756 11.605C17.4756 11.2472 17.1852 10.9568 16.8273 10.9568H16.826Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_564_355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.29,
    height: 22.29,
    fill: "white",
    transform: "translate(0.771973 0.488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.0322f92afc13d1909465906ed1d7dd6a.svg";
export { ForwardRef as ReactComponent };